import axiosInstance from "../api/axios";

// Zumale/BuildVizer-admin read-only Projects browser (all projects across developers). ZUMALE only.

// params: { developerId?, city?, status?, search?, page?, pageSize? } -> { items, total, page, ... }
export const getAdminProjects = (params) => axiosInstance.get(`/admin/projects`, { params });

// -> { developers: [{ id, name }], cities: [string] }
export const getAdminProjectFilters = () => axiosInstance.get(`/admin/projects/filters`);

// Flip a BV-managed (internal) project's owner to an already-onboarded developer customer.
export const transferProjectOwner = (projectId, targetCustomerId) =>
  axiosInstance.post(`/admin/projects/${projectId}/transfer-owner`, { targetCustomerId });

// Candidate target developers (customers that already have a subscription).
export const getDeveloperCustomers = () =>
  axiosInstance.get(`/customers/subscription`, { params: { customerType: "DEVELOPER", pageSize: 500 } });
